module.exports = __webpack_public_path__ + "static/media/logo.9a99eea9.png";